module.exports = __webpack_public_path__ + "static/img/banner.c48382a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/banner.jpg
// module id = nbPf
// module chunks = 0